import { render, staticRenderFns } from "./flagDetail.vue?vue&type=template&id=dd7a57e6&scoped=true&"
import script from "./flagDetail.vue?vue&type=script&lang=js&"
export * from "./flagDetail.vue?vue&type=script&lang=js&"
import style0 from "./flagDetail.vue?vue&type=style&index=0&id=dd7a57e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7a57e6",
  null
  
)

export default component.exports